import { QueryKeysEnum } from '@/enums';
import { BaseService } from './base.service';
import { AlertCountParam, AlertEntity } from '@/types/email-alert';
import APIService from './axios.service';

class AlertService extends BaseService<'alert', AlertEntity> {
  constructor() {
    super(QueryKeysEnum.ALERT);
  }

  getHistoricalCount = (payload: AlertCountParam): Promise<number> => {
    return APIService.get(this.path + '/count', { params: payload });
  };
}

export const alertService = new AlertService();
